import { useState, useEffect, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import VAdjCard from "../Cards/VAdjCard";
import { getAdjCourt } from "../../utils/getAdjCourts";
import ScrollToTop from "../ScrollToTop";

const ViewAdjCase = () => {
  const [singleCase, setSingleCase] = useState();
  let params = useParams();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  const [singleUpdates, setSingleUpdates] = useState();
  const [state, updateState] = useState();
  const [loading, setLoading] = useState();

  const forceUpdate = useCallback(() => updateState({}), []);

  useEffect(() => {
    let title = "";
    if (singleCase?.note !== undefined && singleCase?.note?.trim() !== "") {
      title = title + singleCase.note + " | ";
    }
    title =
      title +
      getAdjCourt(singleCase?.court) +
      " | " +
      singleCase?.arkat +
      "| MySolon.gr";

    document.title = title;
  }, [location, singleCase]);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getCase = async () => {
      try {
        setLoading(true);
        const response = await axiosPrivate.get(`/adjustice/${params.caseId}`, {
          signal: controller.signal,
        });
        const updates = await axiosPrivate.get(`/adjupd/${params.caseId}`, {
          signal: controller.signal,
        });
        isMounted && setSingleCase(response.data);
        isMounted && setSingleUpdates(updates.data);
        setLoading(false);
      } catch (err) {
        console.error(err);
        navigate("/login", { state: { from: location }, replace: true });
      }
    };

    getCase();

    return () => {
      isMounted = false;
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
  console.log(singleUpdates);

  if (
    singleCase && // 👈 null and undefined check
    Object.keys(singleCase).length !== 0 &&
    Object.getPrototypeOf(singleCase) === Object.prototype
  ) {
    console.log(singleCase);
  }

  return (
    singleCase && (
      <div>
        <ScrollToTop />
        <VAdjCard singleCase={singleCase} singleUpdates={singleUpdates} />
      </div>
    )
  );
};

export default ViewAdjCase;
